// extracted by mini-css-extract-plugin
module.exports = {"container":"Numeral_container__xDz5u","positive":"Numeral_positive__oqwTS","negative":"Numeral_negative__SXQL4","neutral":"Numeral_neutral__qnj7i"};